/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box } from '@towersystems/towersystems-design-system';
import { compact } from 'lodash';
/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { isModalVisible } from 'state/ui/selectors';
import { stopEditingLocation } from 'state/ui/location-modal/actions';
import { getLocationId } from 'state/ui/location-modal/selectors';
import { getEditedLocation } from 'state/locations/selectors';
import LocationForm from 'blocks/location-form';
import { successNotice } from 'state/notices/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const EditLocationModal = ({ locationId, location, isVisible, close, ...props }) => {
    const [submitting, setSubmitting] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const isNew = !locationId;
    const title = isNew ? 'Create Location' : 'Edit location';

    const buttons = compact([
        {
            key: 'cancel',
            label: 'Cancel',
            onClick: close,
        },
        {
            key: 'save',
            label: submitting ? 'Saving' : 'Save',
            form: 'location-form',
            type: 'submit',
            disabled: submitting,
            primary: true,
        },
    ]);

    const onSuccess = () => {
        close();
        props.successNotice("Saved");
    }

    return (
        <Modal title={title} className='create-connection-modal' close={close} isVisible={isVisible} buttons={buttons}>
            <Box padding='xlarge'>
                <LocationForm
                    locationId={locationId}
                    beforeSubmit={() => setSubmitting(true)}
                    afterSubmit={() => setSubmitting(false)}
                    afterSuccessfullSubmit={onSuccess}
                    location={location}
                />
            </Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        isVisible: isModalVisible('EditLocationModal')(state),
        locationId: getLocationId(state),
        location: getEditedLocation(state, getLocationId(state)) || {},
    }),
    {
        close: stopEditingLocation,
        successNotice
    },
)(EditLocationModal);
